// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEmployeeAlertsQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.ListEmployeeAlertFilterInput>;
}>;

export type ListEmployeeAlertsQuery = { __typename?: 'Query' } & {
  listEmployeeAlertsByEmployee: { __typename?: 'ListEmployeeAlertsByEmployee' } & Pick<
    Types.ListEmployeeAlertsByEmployee,
    'totalCount'
  > & {
      countByPriority: { __typename?: 'EmployeeAlertCountByPriority' } & Pick<
        Types.EmployeeAlertCountByPriority,
        'high' | 'medium' | 'low'
      >;
      items: Array<
        { __typename?: 'ListEmployeeAlertItemByEmployee' } & Pick<
          Types.ListEmployeeAlertItemByEmployee,
          'id' | 'contractType' | 'companyName'
        > & {
            employee: { __typename?: 'Employee' } & Pick<Types.Employee, 'status'> & {
                generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                  Types.EmployeeGeneralInformation,
                  'preferredFullName'
                >;
              };
            country: Types.Maybe<{ __typename?: 'Country' } & Pick<Types.Country, 'name'>>;
            reasons: Array<
              | ({ __typename: 'EmployeeAlertAgeOutOfRange' } & Pick<
                  Types.EmployeeAlertAgeOutOfRange,
                  'dateOfBirth' | 'age' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertContractsNotContinuous' } & Pick<
                  Types.EmployeeAlertContractsNotContinuous,
                  'date1' | 'date2' | 'gapDays' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertContractsNotFound' } & Pick<
                  Types.EmployeeAlertContractsNotFound,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertDuplicateCompanyContracts' } & Pick<
                  Types.EmployeeAlertDuplicateCompanyContracts,
                  'conflictingCompanyNames' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertDuplicateJobHistories' } & Pick<
                  Types.EmployeeAlertDuplicateJobHistories,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertDuplicateMainContracts' } & Pick<
                  Types.EmployeeAlertDuplicateMainContracts,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertEmployeeNotInactiveButNoActiveContract' } & Pick<
                  Types.EmployeeAlertEmployeeNotInactiveButNoActiveContract,
                  'lastContractEndDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory' } & Pick<
                  Types.EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory,
                  'lastJobHistoryEndDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertEmptyDateOfBirth' } & Pick<
                  Types.EmployeeAlertEmptyDateOfBirth,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertFirstContractStartDateNotSameAsHiredDate' } & Pick<
                  Types.EmployeeAlertFirstContractStartDateNotSameAsHiredDate,
                  'hiredDate' | 'firstStartDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate' } & Pick<
                  Types.EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate,
                  'hiredDate' | 'firstStartDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertHiredDateBeforeAnyMindStarts' } & Pick<
                  Types.EmployeeAlertHiredDateBeforeAnyMindStarts,
                  'hiredDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertInactiveManager' } & Pick<
                  Types.EmployeeAlertInactiveManager,
                  'priority' | 'summary'
                > & {
                    primaryManager: Types.Maybe<
                      { __typename?: 'Employee' } & Pick<Types.Employee, 'id' | 'status'> & {
                          generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                            Types.EmployeeGeneralInformation,
                            'preferredFullName'
                          >;
                          offBoarding: Types.Maybe<
                            { __typename?: 'EmployeeOffBoarding' } & Pick<
                              Types.EmployeeOffBoarding,
                              'lastWorkingDate' | 'employmentEndDate'
                            >
                          >;
                        }
                    >;
                    dottedLineManager: Types.Maybe<
                      { __typename?: 'Employee' } & Pick<Types.Employee, 'id' | 'status'> & {
                          generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                            Types.EmployeeGeneralInformation,
                            'preferredFullName'
                          >;
                          offBoarding: Types.Maybe<
                            { __typename?: 'EmployeeOffBoarding' } & Pick<
                              Types.EmployeeOffBoarding,
                              'lastWorkingDate' | 'employmentEndDate'
                            >
                          >;
                        }
                    >;
                  })
              | ({ __typename: 'EmployeeAlertInvalidEmployeeCode' } & Pick<
                  Types.EmployeeAlertInvalidEmployeeCode,
                  'detailMessage' | 'contractStartDate' | 'employeeCode' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertInvalidJapanesePhoneticName' } & Pick<
                  Types.EmployeeAlertInvalidJapanesePhoneticName,
                  'detailMessage' | 'japanesePhoneticName' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertInvalidLegalFullName' } & Pick<
                  Types.EmployeeAlertInvalidLegalFullName,
                  'detailMessage' | 'legalFullName' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertInvalidPreferredFullName' } & Pick<
                  Types.EmployeeAlertInvalidPreferredFullName,
                  'detailMessage' | 'preferredFullName' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertJobHistoriesNotContinuous' } & Pick<
                  Types.EmployeeAlertJobHistoriesNotContinuous,
                  'date1' | 'date2' | 'gapDays' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertJobHistoriesNotFound' } & Pick<
                  Types.EmployeeAlertJobHistoriesNotFound,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate' } & Pick<
                  Types.EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate,
                  'lastContractEndDate' | 'lastJobHistoryEndDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastContractEndDateNotSameAsResignationDate' } & Pick<
                  Types.EmployeeAlertLastContractEndDateNotSameAsResignationDate,
                  'lastEndDate' | 'resignationDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastContractWillEnd' } & Pick<
                  Types.EmployeeAlertLastContractWillEnd,
                  'lastEndDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate' } & Pick<
                  Types.EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate,
                  'lastEndDate' | 'resignationDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastJobHistoryWillEnd' } & Pick<
                  Types.EmployeeAlertLastJobHistoryWillEnd,
                  'lastEndDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastWorkingDateBeforeAnyMindStarts' } & Pick<
                  Types.EmployeeAlertLastWorkingDateBeforeAnyMindStarts,
                  'lastWorkingDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertLastWorkingDateBeforeHiredDate' } & Pick<
                  Types.EmployeeAlertLastWorkingDateBeforeHiredDate,
                  'hiredDate' | 'lastWorkingDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertProbationFailedStillEmployed' } & Pick<
                  Types.EmployeeAlertProbationFailedStillEmployed,
                  'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertResignationDateBeforeAnyMindStarts' } & Pick<
                  Types.EmployeeAlertResignationDateBeforeAnyMindStarts,
                  'resignationDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertResignationDateBeforeHiredDate' } & Pick<
                  Types.EmployeeAlertResignationDateBeforeHiredDate,
                  'hiredDate' | 'resignationDate' | 'priority' | 'summary'
                >)
              | ({ __typename: 'EmployeeAlertResignationDateBeforeLastWorkingDate' } & Pick<
                  Types.EmployeeAlertResignationDateBeforeLastWorkingDate,
                  'lastWorkingDate' | 'resignationDate' | 'priority' | 'summary'
                >)
            >;
          }
      >;
    };
};

export const ListEmployeeAlertsDocument = /*#__PURE__*/ gql`
    query listEmployeeAlerts($filter: ListEmployeeAlertFilterInput) {
  listEmployeeAlertsByEmployee(filter: $filter) {
    totalCount
    countByPriority {
      high
      medium
      low
    }
    items {
      id
      employee {
        status
        generalInformation {
          preferredFullName
        }
      }
      contractType
      country {
        name
      }
      companyName
      reasons {
        __typename
        priority
        summary
        ... on EmployeeAlertAgeOutOfRange {
          dateOfBirth
          age
        }
        ... on EmployeeAlertContractsNotContinuous {
          date1
          date2
          gapDays
        }
        ... on EmployeeAlertEmployeeNotInactiveButNoActiveContract {
          lastContractEndDate
        }
        ... on EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory {
          lastJobHistoryEndDate
        }
        ... on EmployeeAlertResignationDateBeforeAnyMindStarts {
          resignationDate
        }
        ... on EmployeeAlertResignationDateBeforeHiredDate {
          hiredDate
          resignationDate
        }
        ... on EmployeeAlertResignationDateBeforeLastWorkingDate {
          lastWorkingDate
          resignationDate
        }
        ... on EmployeeAlertFirstContractStartDateNotSameAsHiredDate {
          hiredDate
          firstStartDate
        }
        ... on EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate {
          hiredDate
          firstStartDate
        }
        ... on EmployeeAlertHiredDateBeforeAnyMindStarts {
          hiredDate
        }
        ... on EmployeeAlertInactiveManager {
          primaryManager {
            id
            status
            generalInformation {
              preferredFullName
            }
            offBoarding {
              lastWorkingDate
              employmentEndDate
            }
          }
          dottedLineManager {
            id
            status
            generalInformation {
              preferredFullName
            }
            offBoarding {
              lastWorkingDate
              employmentEndDate
            }
          }
        }
        ... on EmployeeAlertInvalidEmployeeCode {
          detailMessage
          contractStartDate
          employeeCode
        }
        ... on EmployeeAlertInvalidJapanesePhoneticName {
          detailMessage
          japanesePhoneticName
        }
        ... on EmployeeAlertInvalidLegalFullName {
          detailMessage
          legalFullName
        }
        ... on EmployeeAlertInvalidPreferredFullName {
          detailMessage
          preferredFullName
        }
        ... on EmployeeAlertJobHistoriesNotContinuous {
          date1
          date2
          gapDays
        }
        ... on EmployeeAlertLastContractEndDateNotSameAsResignationDate {
          lastEndDate
          resignationDate
        }
        ... on EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate {
          lastContractEndDate
          lastJobHistoryEndDate
        }
        ... on EmployeeAlertLastContractWillEnd {
          lastEndDate
        }
        ... on EmployeeAlertLastJobHistoryWillEnd {
          lastEndDate
        }
        ... on EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate {
          lastEndDate
          resignationDate
        }
        ... on EmployeeAlertLastWorkingDateBeforeAnyMindStarts {
          lastWorkingDate
        }
        ... on EmployeeAlertLastWorkingDateBeforeHiredDate {
          hiredDate
          lastWorkingDate
        }
        ... on EmployeeAlertDuplicateCompanyContracts {
          conflictingCompanyNames
        }
      }
    }
  }
}
    `;

/**
 * __useListEmployeeAlertsQuery__
 *
 * To run a query within a React component, call `useListEmployeeAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeAlertsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListEmployeeAlertsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>(
    ListEmployeeAlertsDocument,
    options,
  );
}
export function useListEmployeeAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>(
    ListEmployeeAlertsDocument,
    options,
  );
}
// @ts-expect-error
export function useListEmployeeAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>;
export function useListEmployeeAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEmployeeAlertsQuery | undefined, ListEmployeeAlertsQueryVariables>;
export function useListEmployeeAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEmployeeAlertsQuery, ListEmployeeAlertsQueryVariables>(
    ListEmployeeAlertsDocument,
    options,
  );
}
export type ListEmployeeAlertsQueryHookResult = ReturnType<typeof useListEmployeeAlertsQuery>;
export type ListEmployeeAlertsLazyQueryHookResult = ReturnType<typeof useListEmployeeAlertsLazyQuery>;
export type ListEmployeeAlertsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeAlertsSuspenseQuery>;
